import {takeLatest, put,select} from 'redux-saga/effects';
import {actions as listActions} from '../slices/RoleListSlice';
import {actions} from '../slices/RoleSlice';
import NetworkHandler from 'utils/network';
import config from 'config';
import NotificationHandler from 'utils/notification';
import ModalHandler from 'utils/modal';

const getSearchCriteria = state => state.roleList.searchCriteria;

function* getRoleList({payload: {page, limit, filters}}) {
    try {
        const response = yield NetworkHandler.get(`${config.getUrl('bus_roles')}`, {
            params: {
                ...filters,
                page: page ? page - 1 : null,
                size: limit,
            }
        });
        yield put({type: listActions.get_list_succeed.type, payload: {...response.data}});
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({type: listActions.get_list_failed.type, payload: error});
    }
}



function* createRole({payload:{params}}) {
    try {
        const response = yield NetworkHandler.post(`${config.getUrl('bus_roles')}`, {
            ...params
        });
        yield put({type: actions.create_role_succeed.type, payload: {...response}});
        NotificationHandler.notifySuccess('Thêm thành công!');
        const searchCriteria = yield select(getSearchCriteria);
        yield put({type: listActions.get_list.type, payload: {...searchCriteria}});
        yield ModalHandler.closeAllModal();
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({type: actions.create_role_failed.type, payload: error});
    }
}

function* updateRole({payload:{params}}) {
    try {
        const response = yield NetworkHandler.put(`${config.getUrl('bus_roles')}/${params.id}`, {
            ...params
        });
        yield put({type: actions.create_role_succeed.type, payload: {...response}});
        NotificationHandler.notifySuccess('Cập nhật thành công!');
        const searchCriteria = yield select(getSearchCriteria);
        yield put({type: listActions.get_list.type, payload: {...searchCriteria}});
        yield ModalHandler.closeAllModal();
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({type: actions.create_role_failed.type, payload: error});
    }
}

function* deleteRole({payload:{id}}) {
    try {
        const response = yield NetworkHandler.delete(`${config.getUrl('bus_roles')}/${id}`);
        yield put({type: actions.delete_role_succeed.type, payload: {...response}});
        NotificationHandler.notifySuccess('Xoá thành công!');
        const searchCriteria = yield select(getSearchCriteria);
        yield put({type: listActions.get_list.type, payload: {...searchCriteria}});
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({type: actions.delete_role_failed.type, payload: error});
    }
}

function* watchRequestDetail() {
    yield takeLatest(listActions.get_list.type, getRoleList);
    yield takeLatest(actions.create_role.type, createRole);
    yield takeLatest(actions.update_role.type, updateRole);
    yield takeLatest(actions.delete_role.type, deleteRole);
}

export default watchRequestDetail;